'use client';

import { scrollPositionCache } from '@/lib/algolia/searchCache';
import { useEffect } from 'react';

export function useRestorePosition() {
  useEffect(() => {
    const scrollPosition = scrollPositionCache.read();
    if (scrollPosition) {
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
        scrollPositionCache.remove();
      }, 120);
    }
  }, []);
}
